export interface ApplicantStateEditModel {
  id: string;
  status_id: string;
}

export interface ApplicantsStateBulkEditModel {
  applicants: ApplicantStateEditModel[] | null;
}

export interface ApplicantTagEditModel {
  id: string;
  label: string | null;
}

export interface ApplicantBulkTagEditModel {
  applicant_ids: string[] | null;
  labels: string[] | null;
}

export interface UserContactTranslationModel {
  language: string | null;
  text: string | null;
  subject: string | null;
}

export interface ApplicantsContactModel {
  company_id: string;
  vacancy_id: string;
  scheduled_at: string | null;
  domain_email_id: string | null;
  domain_id: string | null;
  cc_to_sender: boolean | null;
  translations: UserContactTranslationModel[] | null;
  recipients: string[] | null;
}
